import React from 'react';
import styled from 'styled-components';
import { Grid } from '@material-ui/core';

export const StyledGrid = styled(
  ({ textAlign, marginBottom, ...otherProps }) => <Grid {...otherProps} />,
)`
  text-align: ${(props) => props.textAlign} !important;
  margin-bottom: ${(props) => props.marginBottom} !important;
  min-height: 150px !important;
  margin-top: 10px !important;
`;
